/**
 * View codes for the nexpim app, mirroring `domain-nexpim`'s `NexpimView`.
 * The strings are the contract with `AccountDTO.view_codes`.
 *
 * These exist so route and nav gating can name a code without a string
 * literal. They are NOT the catalogue the users screen offers: that comes from
 * `GET /account/views`, straight off the Java enum, because this file had
 * already drifted once — 20 codes against the enum's 32 — and a picker built
 * on a partial list silently revokes what it cannot see.
 *
 * Generated from the Java enum. Regenerate rather than hand-edit.
 */
export const NexpimView = {
  /** Home */
  HOME: "NEXPIM_HOME",
  /** Products */
  PRODUCTS: "NEXPIM_PRODUCTS",
  /** Parts */
  PARTS: "NEXPIM_PARTS",
  /** Services */
  SERVICES: "NEXPIM_SERVICES",
  /** API inventory updates */
  API_INVENTORY_UPDATES: "NEXPIM_API_INVENTORY_UPDATES",
  /** Product pricing */
  PRICING_PRODUCT: "NEXPIM_PRICING_PRODUCT",
  /** Product pricing discounts */
  PRICING_PRODUCT_DISCOUNT: "NEXPIM_PRICING_PRODUCT_DISCOUNT",
  /** Pricing rules */
  PRICING_RULES: "NEXPIM_PRICING_RULES",
  /** Production pipeline */
  PRODUCTION_PIPELINE: "NEXPIM_PRODUCTION_PIPELINE",
  /** Production project */
  PRODUCTION_PROJECT: "NEXPIM_PRODUCTION_PROJECT",
  /** Manual invoices */
  MANUAL_INVOICES: "NEXPIM_MANUAL_INVOICES",
  /** Sales analysis */
  SALES_ANALYSIS: "NEXPIM_SALES_ANALYSIS",
  /** Client margin */
  SALES_CLIENT_MARGIN: "NEXPIM_SALES_CLIENT_MARGIN",
  /** Sales invoices */
  SALES_INVOICES: "NEXPIM_SALES_INVOICES",
  /** Sales orders */
  SALES_ORDERS: "NEXPIM_SALES_ORDERS",
  /** Auto product discontinuation */
  CONFIG_AUTOMATIC_PRODUCT_DISCONTINUATION: "NEXPIM_CONFIG_AUTOMATIC_PRODUCT_DISCONTINUATION",
  /** COGS expenses */
  CONFIG_COGS_EXPENSE: "NEXPIM_CONFIG_COGS_EXPENSE",
  /** Product categories */
  CONFIG_PRODUCT_CATEGORY: "NEXPIM_CONFIG_PRODUCT_CATEGORY",
  /** Product COGS */
  CONFIG_PRODUCT_COGS: "NEXPIM_CONFIG_PRODUCT_COGS",
  /** Product collections */
  CONFIG_PRODUCT_COLLECTION: "NEXPIM_CONFIG_PRODUCT_COLLECTION",
  /** Product designers */
  CONFIG_PRODUCT_DESIGNER: "NEXPIM_CONFIG_PRODUCT_DESIGNER",
  /** Product metafields */
  CONFIG_PRODUCT_METAFIELD: "NEXPIM_CONFIG_PRODUCT_METAFIELD",
  /** Product tags */
  CONFIG_PRODUCT_TAG: "NEXPIM_CONFIG_PRODUCT_TAG",
  /** Units and measurements */
  CONFIG_UNIT: "NEXPIM_CONFIG_UNIT",
  /** Plant structure */
  CONFIG_PLANT: "NEXPIM_CONFIG_PLANT",
  /** Part groups */
  CONFIG_PART_GROUP: "NEXPIM_CONFIG_PART_GROUP",
  /** Manufacturing parts */
  MANUFACTURING_PARTS: "NEXPIM_MANUFACTURING_PARTS",
  /** Stock */
  MANUFACTURING_STOCK: "NEXPIM_MANUFACTURING_STOCK",
  /** Purchasing */
  PURCHASING: "NEXPIM_PURCHASING",
  /** Not a page: approving purchase orders at or above the threshold. */
  PURCHASE_APPROVAL: "NEXPIM_PURCHASE_APPROVAL",
  /** Production orders */
  PRODUCTION_ORDERS: "NEXPIM_PRODUCTION_ORDERS",
  /** Service desk */
  SERVICE_DESK: "NEXPIM_SERVICE_DESK",
  /** Shop floor board */
  SHOP_FLOOR: "NEXPIM_SHOP_FLOOR",
  /** Shop floor station */
  SHOP_FLOOR_STATION: "NEXPIM_SHOP_FLOOR_STATION",
  /** Terrebonne packing */
  TERREBONNE_PACKING: "NEXPIM_TERREBONNE_PACKING",
  /** Shop floor setup */
  CONFIG_SHOP_FLOOR: "NEXPIM_CONFIG_SHOP_FLOOR",
  /** Part attributes */
  CONFIG_ATTRIBUTE: "NEXPIM_CONFIG_ATTRIBUTE",
  /** Suppliers */
  SUPPLIERS: "NEXPIM_SUPPLIERS",
  /** Settings: general, products, production (rank bands), pricing (exchange rates) */
  CONFIG_SETTINGS: "NEXPIM_CONFIG_SETTINGS",
  /** Account administration */
  ADMIN_ACCOUNTS: "NEXPIM_ADMIN_ACCOUNTS",
  /** Admin actions: the jobs otherwise left to cron, behind buttons */
  ADMIN_ACTIONS: "NEXPIM_ADMIN_ACTIONS",
} as const;

export type NexpimViewCode = (typeof NexpimView)[keyof typeof NexpimView];
